import { C, font } from '../theme/tokens';
import type { Task } from '../domain/types';
import { useApp } from '../state/store';
import { dayLabel } from '../lib/dates';
import { Avatar } from './ui';

/** One task row. Only the owner can tick; others see the owner and a dimmed box. */
export function TaskRow({ task, today, context, showOwner, onOpen, size = 36 }: { task: Task; today: string; context?: string; showOwner?: boolean; onOpen?: () => void; size?: number }) {
  const { state: { data }, act } = useApp();
  const mine = task.ownerId === data.me;
  const owner = data.ambassadors[task.ownerId];
  const dueToday = task.due === today && !task.done;
  const due = task.done ? 'Done' : task.due === today ? 'Due today' : `Due ${dayLabel(task.due)}`;
  return (
    <div style={{ display: 'grid', gridTemplateColumns: showOwner ? `${size + 4}px 1fr 30px` : `${size + 4}px 1fr`, alignItems: 'center', gap: 10, padding: '11px 0', borderTop: `1px solid ${C.divider}`, minHeight: 56 }}>
      <button type="button" className="hit" onClick={() => act.toggleTask(task.id)} aria-pressed={task.done}
        aria-label={mine ? `${task.done ? 'Mark not done' : 'Mark done'}: ${task.title}` : `${task.title}, owned by ${owner?.name}`}
        style={{ width: size, height: size, borderRadius: size / 3, border: `2px solid ${task.done ? C.ink : mine ? C.violet : C.border}`, background: task.done ? C.ink : 'transparent', color: C.white,
          display: 'flex', alignItems: 'center', justifyContent: 'center', font: font(800, 15, 1), transition: 'all .2s', transform: task.done ? 'rotate(-8deg)' : 'none', opacity: mine ? 1 : 0.55 }}>
        {task.done ? '✓' : ''}
      </button>
      <button type="button" onClick={onOpen} disabled={!onOpen} style={{ display: 'flex', flexDirection: 'column', gap: 3, border: 0, background: 'transparent', padding: 0, textAlign: 'left', cursor: onOpen ? 'pointer' : 'default' }}>
        <span style={{ font: font(600, 15, 1.25), color: task.done ? C.grey : C.ink, textDecoration: task.done ? 'line-through' : 'none' }}>{task.title}</span>
        <span style={{ font: font(500, 11, 1.3), color: C.grey }}>
          {[context, showOwner ? (mine ? 'You' : owner?.name) : null].filter(Boolean).join(' · ')}
          {context || showOwner ? ' · ' : ''}
          <span style={{ color: dueToday ? C.amber : C.grey }}>{due}</span>
        </span>
      </button>
      {showOwner && owner && <Avatar person={owner} size={30} />}
    </div>
  );
}

